export function preventEvent(e) {
    e.preventDefault();
    e.stopPropagation();
}
